const apiBaseUrl =  'https://my-api.webeasytools.com/api'
const imageBaseurl =  'https://my-api.webeasytools.com/uploads/'
// const apiBaseUrl =  'http://localhost:5000/api'
// const imageBaseurl =  'http://localhost:5000/uploads/'

const postType =[
  {
    name: "Blog",
    value: "blog",
  },
  {
    name: "Post",
    value: "post",
  },
]
export{
  apiBaseUrl,imageBaseurl, postType
}